<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Supplier Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Name</label>
                <input type="text" class="form-control" v-model="supp.name" id="name" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label>Phone Number</label>
                <input type="text" class="form-control" v-model="supp.phone" id="phone" aria-describedby="module">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" v-model="supp.email" id="email" aria-describedby="module">
            </div>
            <div class="form-group col-9">
                <label for="module">Province</label>
                <app-lookup-field :model="supp" :element="provinceLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label>Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="supp.address" rows="3"></textarea>
            </div>
        </div>

        <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="supp.mailManagementDetail"></app-datatable> -->
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Supplier } from '../../models/supplier'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            supp: {
                ...Supplier
            },
            provinceLookup: {
                id: 'province',
                title: 'Province',
                type: 'form',
                apiUrl: 'province-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Province',
                        width: 4,
                        column: 'provinceName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Province Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'provinceId'
                    },
                    {
                        from: 'name',
                        to: 'provinceName'
                    }
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const suppApi = api('Supplier/detail')

            const suppResult = await suppApi.getWithParams(this.$route.query.id)
            this.supp = suppResult
        }
    },
    methods: {
        async save() {
            const suppApi = api('Supplier')
            if(this.$route.query.id !== undefined) {
                await suppApi.update(this.supp, this.$route.query.id)
            } else {
                await suppApi.create(this.supp)
            }
            this.$router.push({ name: 'supplier' })
        },
        cancel() {
            this.$router.push({ name: 'supplier' })
        },
        finishLookup(data) {
            const currentSupp = this.supp
            this.supp = {
                ...currentSupp,
                ...data
            }
        },
        selectChange(data) {
            const currentData = this.supp
            this.supp = {
                ...currentData,
                ...data
            }
        },
    }
}
</script>